import React from 'react';
import { Link } from 'react-router-dom';

const CARDS = [
  { icon: '📥', label: 'Captação',                      desc: 'Funil de implantações',        href: '/dashboard-implantacao',    color: '#6366f1' },
  { icon: '🏥', label: 'Hospitalização',                desc: 'Ocorrências hospitalares',      href: '/dashboard-hospitalizacao', color: '#0ea5e9' },
  { icon: '🏠', label: 'Censo Homecare',                desc: 'Indicadores de assistência',    href: '/dashboard-indicadores',    color: '#10b981' },
  { icon: '🩺', label: 'Acomp. Visitas Domiciliares',  desc: 'Controle de visitas em falta',  href: '/dashboard-visitas',        color: '#0f766e' },
  { icon: '📞', label: 'Dashboard Telefonia',           desc: 'Análise de ligações',           href: '/dashboard-planilha',       color: '#f59e0b' },
  { icon: '🔴', label: 'Telefonia ao Vivo',             desc: 'Filas do home em tempo real',   href: '/telefonia-ao-vivo',        color: '#ef4444' },
  { icon: '📈', label: 'Dashboard Projeto IW',          desc: 'Relatórios e análises',         href: '/analysis',                 color: '#8b5cf6' },
  { icon: '📤', label: 'Uploads',                       desc: 'Gerenciador de arquivos',       href: '/uploads',                  color: '#64748b' },
  { icon: '🩹', label: 'Dashboard Feridas',             desc: 'Gestão de lesões e trocas de curativo',      href: '/dashboard-feridas',       color: '#f43f5e' },
];

export default function DashboardHub() {
  return (
    <div style={{ padding: '40px 32px', background: '#f8fafc', minHeight: '100vh' }}>
      <h2 style={{ margin: '0 0 6px', fontSize: '1.4rem', fontWeight: 800, color: '#1e293b' }}>🗂 Dashboards</h2>
      <p style={{ margin: '0 0 36px', color: '#64748b', fontSize: '0.9rem' }}>Acesse os painéis de cada área do sistema</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 20 }}>
        {CARDS.map(d => (
          <Link key={d.label} to={d.href}
            style={{ textDecoration: 'none', background: '#fff', borderRadius: 14, padding: '24px 20px',
              border: '1px solid #e2e8f0', boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
              display: 'flex', flexDirection: 'column', gap: 10, transition: 'all 0.15s' }}
            onMouseEnter={e => { e.currentTarget.style.boxShadow = `0 8px 24px ${d.color}30`; e.currentTarget.style.borderColor = d.color; }}
            onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.06)'; e.currentTarget.style.borderColor = '#e2e8f0'; }}>
            <div style={{ width: 48, height: 48, borderRadius: 12, background: `${d.color}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 }}>{d.icon}</div>
            <div>
              <div style={{ fontWeight: 800, fontSize: '0.95rem', color: '#1e293b' }}>{d.label}</div>
              <div style={{ fontSize: '0.78rem', color: '#64748b', marginTop: 2 }}>{d.desc}</div>
            </div>
            <div style={{ marginTop: 'auto', fontSize: '0.75rem', color: d.color, fontWeight: 700 }}>Abrir →</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
